import React from "react";
import { RouteMetrics } from "../../generated/gpb/api/route";
import { getSummaryRouteMetrics } from "./RouteUtils";
import RouteMetricsCard from "./MetricsCard";
import OvernightsCard from "./OvernightsCard";

type RouteMetricsContentProps = {
    routeMetrics: Array<RouteMetrics>,
    showTemps: boolean,
};


export function RouteMetricsContent( {
    routeMetrics,
    showTemps,
}: Readonly<RouteMetricsContentProps> )
{
    const [ selectedDates, setSelectedDates ] = React.useState<Set<number>>( new Set<number>() );
    const overview = getSummaryRouteMetrics( routeMetrics, selectedDates );

    const handleDateSelect = ( dateValue: Date, isShiftClick: boolean ) =>
    {
        setSelectedDates( ( prev ) =>
        {
            const newSelectedDates = new Set<number>( prev );

            if ( isShiftClick )
            {
                if ( newSelectedDates.has( dateValue.getTime() ) )
                {
                    newSelectedDates.delete( dateValue.getTime() );
                }
                else
                {
                    newSelectedDates.add( dateValue.getTime() );
                }
            }
            else
            {
                newSelectedDates.clear();
                newSelectedDates.add( dateValue.getTime() );
            }

            return newSelectedDates;
        } );
    };

    return (
        <React.Fragment>
            <div style = {{ paddingTop: "5px" }}>
                <RouteMetricsCard metrics = {overview} routeMetrics = {routeMetrics} selectedDates = {selectedDates} onDateSelect = {handleDateSelect} setSelectedDates = {setSelectedDates}/>
            </div>
            {showTemps &&
            <div>
                <OvernightsCard/>
            </div>}
        </React.Fragment>
    );
}
